const getters = {
  featureRequests: (state) => state.featureRequests,
  loading: (state) => state.loading,
  currentPage: (state) => state.currentPage,
  pageSize: (state) => state.pageSize,
  totalPages: (state) => state.pagination.total_pages || 0,
  totalItems: (state) => state.pagination.total_items || 0,
  sortOrder: (state) => state.sortOrder,
  pagination: (state) => state.pagination,
  votedRequestIds: (state) => state.votedRequestIds,
  hasVoted: (state) => (requestId) => state.votedRequestIds.includes(requestId),
};

export default getters;
